import { render } from "./UsuarioJornadas.vue?vue&type=template&id=72b74bc3"
import script from "./UsuarioJornadas.vue?vue&type=script&lang=js"
export * from "./UsuarioJornadas.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__